const popups = {};

function importAll(context) {
  context.keys().forEach(key => (popups[key] = context(key)));
}

importAll(require.context('../../../core/popups', true, /\.(html)$/));

/**
 * <cfn-select reference />
 * Allows to select a reference to a core entity using a popup.
 * Data is fetch from <basePath>[<pathExt>][?param=<serviceParam>]
 * Parameter:
 * pathExt: string - "Sub path" added to the base path on HTTP request, starts with leading slash
 * serviceParam: string - Query value that is added to HTTP request
 */
angular.module('cfn').directive('cfnSelectReference', cfnSelectReference);

cfnSelectReference.$inject = ['$rootScope', '$log', 'pathFilter'];
function cfnSelectReference($rootScope, $log, pathFilter) {
  return {
    restrict: 'E',
    scope: {
      result: '&',
      onselect: '&',
      class: '@',
      readonly: '=',
      title: '@',
      type: '@',
      popoverPath: '@',
      required: '@',
      multiselect: '@',
      param: '=param',
      serviceParam: '@',
      pathExt: '@',
      placement: '@'
    },
    transclude: true,
    replace: true,
    template: template,
    link: link
  };

  function template(element, attributes) {
    // This was done via an expression in the template before, but for some reason it triggered the filter all
    // the time (e.g. when a unrelated input field was changed!) which spammed the log with logging statements.
    // This way the filter is only evaluated once.
    //TODO: moritz evaluating once does not work as the attributes.type can be an expression. see output of: console.debug("Popup",popover,pathFilter(attributes.type, 'popup'),attributes.type); added a variable popoverPath to scope

    return '<span class="popover-btn"><button type="button" popover-append-to-body="true" popover-result="onResult" popover-animation="true" popover-titletext="{{ title }}" popover-placement="{{placement}}" data365-popover="{{popover}}" class="btn popover-btn {{class}}" ng-transclude=""></button></span>';
  }

  function link(scope, element, attrs) {
    attrs.$observe('type', function(value) {
      if (value) {
        // update popup path to type changes if type is an expression
        let popover = popups['./' + value + 'Popup.html'];

        if (!popover) {
          popover = pathFilter(value, 'popup') + value + 'Popup.html';
        }

        scope.popover = popover;

        // Don't allow to manage system entities (sysXXX)
        scope.enableBackToCore = value.indexOf('sys') !== 0;
      }
    });

    attrs.$observe('popoverPath', function(value) {
      if (value) {
        scope.popover = value;

        scope.enableBackToCore = true;
      }
    });

    scope.$rootScope = $rootScope;
    scope.allowMultiSelect = scope.multiselect == 'true';
    scope.onResult = function(elements) {
      if (scope.result()) {
        var showDetails = elements.length == 1;

        if (attrs.aggregatedAdd === 'true') {
          scope.result()(elements);
        } else {
          // Show details only if not multiple activated at once
          elements.forEach(function(ob) {
            scope.result()(ob, showDetails);
          });
        }
      } else if (scope.onselect()) {
        scope.onselect()(elements);
      } else {
        $log.error('no result function set!');
      }
    };

    // Close popover dialog with ESC key.
    $('.popover-btn').on('keyup', function(e) {
      // 27: ESC
      if (e.keyCode === 27) {
        $('.f-abort').click();
      }
    });

    attrs.$observe('placement', function(val) {
      scope.placement = angular.isDefined(val) ? val : 'bottom';
    });

    scope.getParam = function() {
      return scope.param;
    };
  }
}
